import * as React from "react";
import Empty from "../empty";
import {
    List,
    Create,
    Edit,
    Datagrid,
    TextField,
    SimpleForm,
    TextInput,
    EditButton, NumberInput, NumberField, SaveButton, TopToolbar, CreateButton, ExportButton, useGetIdentity
} from 'react-admin';
import Toolbar from "@material-ui/core/Toolbar";
import {Button} from "@material-ui/core";
import {BarLoader} from "react-spinner-animated";

const postFilters = [
    <TextInput source="q" label="Search" alwaysOn/>,
];

const ToolbarButtons = (props) => (
    <TopToolbar>
        <CreateButton disabled={props.identity.admin} label={"Nuovo"}/>
        <ExportButton label={"Esporta"}/>
        {/* Add your custom actions */}
    </TopToolbar>
)

const PostEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton disabled={props.identity.admin} label={"Salva"} submitOnEnter={false}
                    redirect={props.redirect} {...props} />
        <Button href={"#/warranty"}>Annulla</Button>
    </Toolbar>
);

export const WarrantyList = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;

    return (
        <List {...props} perPage={25} filters={postFilters} empty={<Empty/>}
              actions={<ToolbarButtons identity={identity}/>}>
            <Datagrid rowClick="edit">
                <TextField source="description" label="Tipologia" textAlign="center"/>
                <NumberField source="spanInMonths" label="Durata (Anni)" textAlign="center"/>
                <EditButton label="Modifica" textAlign="center"/>
            </Datagrid>
        </List>
    );
}

export const WarrantyCreate = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;

    return (
        <Create {...props}>
            <SimpleForm toolbar={<PostEditToolbar identity={identity}/>}>
                <TextInput source="description" label="Tipologia"/>
                <NumberInput source="spanInMonths" label="Durata (Anni)"/>
            </SimpleForm>
        </Create>
    );
}

export const WarrantyEdit = (props) => {
    const {identity, loading} = useGetIdentity();
    if (loading) return <BarLoader text={"Caricamento..."}
                                   center={true}/>;

    return (
        <Edit {...props}>
            <SimpleForm toolbar={<PostEditToolbar identity={identity}/>}>
                <TextInput disabled label="Id" source="id"/>
                <TextInput source="description" label="Tipologia"/>
                <NumberInput source="spanInMonths" label="Durata (Anni)"/>
            </SimpleForm>
        </Edit>
    );
}